import i18n, { InitOptions, Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import eng from './en.json';
import hun from './hu.json';
import hrv from './hr.json';
import { initI18n } from '@hclinear/hc-linear-react';
import { languageLocalStorageService } from '@service/localStorage/languageLocalStorageService';

const resources: Resource = {
  en: {
    translation: eng,
  },
  hr: {
    translation: hrv,
  },
  hu: {
    translation: hun,
  },
};

initI18n(
  {
    hu: { translation: hun },
    en: { translation: eng },
    hr: { translation: hrv },
  },
  languageLocalStorageService.getLanguage(),
);

const options: InitOptions = {
  resources,
  lng: languageLocalStorageService.getLanguage(),
  fallbackLng: 'hu',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    useSuspense: false,
  },
};

i18n.use(initReactI18next).init(options);

export const { t } = i18n;
export default i18n;
